import { useContext, useMemo, useState } from "react";
import { useTable } from "react-table";
import primaryComponents from "../../../primaryComponents";
import { CopyIcon, DeleteIcon } from "../../../../assets/svgIcons";
import { useNavigate, useSearchParams } from "react-router-dom";
import { pathConstants } from "../../../../routes/pathContants";
import { truncateString } from "../../../../helpers";
import CopyToClipboard from "react-copy-to-clipboard";
import { ToastContext } from "../../../../hooks/context";

export const useBusinessAccountTable = ({ connectionList }) => {
  const [accountDetails, setAccountDetails] = useState(null);
  const [deleteAccountDetails, setDeleteAccountDetails] = useState(null);
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const triggerToast = useContext(ToastContext);

  const columns = useMemo(
    () => [
      {
        Header: "Merchant Name",
        accessor: "merchant_name",
        Cell: ({ cell: { value } }) => value || "N/A",
      },
      {
        Header: "Webhook URL",
        accessor: "webhook_url",
        Cell: ({ cell: { value } }) => (
          <span className="d-flex align-items-center">
            {truncateString(value || "", 20) || "N/A"}

            {value ? (
              <CopyToClipboard
                onCopy={() => {
                  triggerToast("Copied", "success");
                }}
                text={value || ""}
              >
                <primaryComponents.Button
                  classNames={"btn btn--outline smallBtn ml-2"}
                >
                  <CopyIcon color="#7647ee" className="mr-1" />
                </primaryComponents.Button>
              </CopyToClipboard>
            ) : null}
          </span>
        ),
      },
      {
        Header: "Merchant Code",
        accessor: "merchant_code",
        Cell: ({ cell: { value } }) => value || "N/A",
      },
      {
        Header: "Client ID",
        accessor: "client_id",
        Cell: ({ cell: { value } }) => truncateString(value, 20) || "N/A",
      },
      {
        Header: "Client Secret",
        accessor: "client_secret",
        Cell: ({ cell: { value } }) => truncateString(value, 20) || "N/A",
      },
      {
        Header: "Webhook Secret",
        accessor: "webhook_secret",
        Cell: ({ cell: { value } }) => truncateString(value, 20) || "N/A",
      },
      {
        Header: "Action",
        Cell: ({ row }) => (
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <primaryComponents.Button
              onClick={() =>
                navigate(
                  pathConstants.APPS_INTEGRATION_TERMINALS_CONNECT +
                    `?terminal_type=${search.get("terminal_type")}&account_id=${row?.original?.id}`,
                )
              }
              classNames={"btn btn--primary smallBtn"}
            >
              Add Terminal
            </primaryComponents.Button>

            <primaryComponents.Button
              onClick={() => setAccountDetails(row?.original)}
              classNames={"btn btn--outline smallBtn"}
            >
              Update
            </primaryComponents.Button>

            <span
              className="cursor-pointer"
              onClick={() => setDeleteAccountDetails(row?.original)}
            >
              <DeleteIcon />
            </span>
          </div>
        ),
      },
    ],
    [],
  );

  const instance = useTable({ columns, data: connectionList });
  return {
    instance,
    accountDetails,
    deleteAccountDetails,
    setDeleteAccountDetails,
    setAccountDetails,
  };
};
